import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import CustomButton from "../../../components/ui/button";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorMessage from "../partials/error";
import NotificationMessage from "../../../components/notification";
import SectionTitle from "../../../components/sectionTitle";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Backdrop, Box, Button, Stack, Typography } from "@mui/material";
import { ReducerUtils } from "../../../constants/reducers";
import {
  downloadFile,
  getRoute,
  getStorageItem,
  makeid,
  setStorageItem,
} from "../../../helpers/utils";
import { useHistory } from "react-router";
import {
  BUTTON_DOWNLOAD,
  BUTTON_START_AGAIN,
  SLUG_DOWNLOAD,
} from "../../../constants";
import { buildWrapperTokenHeader } from "../../../helpers/lead";
import { postWebService } from "../../../helpers/server";
import {
  buildGenerateDocumentsPayload,
  buildSendInstaPolicyConfirmationPayload,
  buildUpdateOrderPayload,
  buildCreateNastiePayload,
} from "../../../helpers/nominee";

function BuyflowInstaConfirmation({
  classes: { borderContainter, main, loaderBox, autoPayIcon },
}) {
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();
  const [backdrop, setBackdrop] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [errors, setErrors] = useState([]);
  const [form, setForm] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [modal, setModal] = useState({ open: false, snackbar: false });

  useEffect(() => {
    const cbSuccessWrapperToken = ({ access_token }) => {
      toggleFlag(true);
      setStorageItem("access-token", access_token);
      generateDocuments();
    };

    async function wrapperToken() {
      try {
        const header = buildWrapperTokenHeader();
        const response = await postWebService("token.php", {}, header);

        cbSuccessWrapperToken(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    const cbSuccessOrderDetails = ({ status = null }) => {
      if (status && status != "POLICYINSTACONFIRMATION") {
        wrapperToken();
      }
    };

    async function fetchOrderDetails() {
      try {
        const response = await postWebService("orders.php", {
          oid: Number(getStorageItem("oid")),
        });

        cbSuccessOrderDetails(response.data);
      } catch (error) {
        // console.log(error);
      }
    }

    fetchOrderDetails();
  }, []);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleDownload = (url, filename) => downloadFile(url, filename);

  const handleProceed = () => navigateTo(getRoute("home"));

  const navigateTo = (pathname) => history.push({ pathname });

  const toggleFlag = (flag = false) => {
    setIsFormSubmitted(flag);
    setBackdrop(flag);
  };

  const toggleModal = (keyname = "snackbar", flag = true) =>
    setModal({ ...modal, [keyname]: flag });

  const cbError = (error = null) => toggleFlag();

  const cbSuccessUpdateOrder = ({ code, msg }) =>
    code === 201 ? toggleFlag() : toggleFlag();

  const updateOrderDetails = async () => {
    try {
      const response = await postWebService("update-order.php", {
        oid: Number(getStorageItem("oid")),
        status: "POLICYINSTACONFIRMATION",
      });

      cbSuccessUpdateOrder(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessFetchDocuments = ({ data }, checksum) => {
    let dataSlice = data.slice(9);
    dataSlice = dataSlice.slice(0, -8);
    const dataJSON = JSON.parse(atob(dataSlice));
    if (dataJSON.code == 200 && dataJSON.checksum == checksum) {
      dispatchEvent(ReducerUtils.proposal.documents, dataJSON.data);
      toggleModal("snackbar", true);
      updateOrderDetails();
    } else {
      toggleFlag();
    }
  };

  const fetchDocuments = async () => {
    try {
      const checksum = makeid();
      const response = await postWebService("document-listing.php", {
        oid: Number(getStorageItem("oid")),
        checksum,
      });

      cbSuccessFetchDocuments(response.data, checksum);
    } catch (error) {
      cbError(error);
    }
  };

  const cbSyncToOmnidocs = ({ responseCode }) =>
    responseCode === "ODRes000" ? fetchDocuments() : toggleFlag();

  const syncToOmnidocs = async () => {
    try {
      const response = await postWebService(
        "sendtoomnidocs.php",
        buildSendInstaPolicyConfirmationPayload()
      );

      cbSyncToOmnidocs(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessGenerateNastie = ({ code }) =>
    code === 200 ? syncToOmnidocs() : fetchDocuments(); // toggleFlag();

  const generateNastie = async () => {
    try {
      const response = await postWebService(
        "policycreation.php",
        buildCreateNastiePayload()
      );

      cbSuccessGenerateNastie(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessSendDocuments = ({ responseCode }) =>
    responseCode === "EMRes000" ? generateNastie() : toggleFlag();

  const sendDocuments = async () => {
    try {
      const response = await postWebService(
        "instapolicy.php",
        buildSendInstaPolicyConfirmationPayload()
      );

      cbSuccessSendDocuments(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  const cbSuccessGenerateDocuments = ({ code }) =>
    code === 200 ? sendDocuments() : toggleFlag();

  const generateDocuments = async () => {
    try {
      const response = await postWebService(
        "generateDocuments-upf.php",
        buildGenerateDocumentsPayload()
      );

      cbSuccessGenerateDocuments(response.data);
    } catch (error) {
      cbError(error);
    }
  };

  return isLoaded ? (
    <Box className={main}>
      <Box display="flex" justifyContent="center" mt={5}>
        <SectionTitle title={"Insta Policy Confirmation"} hideBack={true} />
      </Box>

      {1 === 2 && (
        <Box mt={3}>
          <Stack
            direction="row"
            gap={1}
            display={"flex"}
            justifyContent={"center"}
            textAlign={"left"}
          >
            <CheckCircleOutlineIcon className={autoPayIcon} />
            <Typography variant="caption" sx={{ color: "green" }}>
              Insta policy confirmation document has been shared with you on
              your registered mobile number and email address.
            </Typography>
          </Stack>
        </Box>
      )}

      <Box className={`${borderContainter}`} p={1} mt={7} pb={2}>
        <Box>
          <Typography variant="caption">
            Thank you for purchasing your policy with us. Please allow us 2
            working days to issue the policy.
          </Typography>
        </Box>

        <Box
          mt={3}
          justifyContent={"center"}
          display="flex"
          sx={{ width: "100%" }}
        >
          {state?.documents?.map((item) => {
            return (
              item.title === "InstaPolicyConfirmation" && (
                <Box key={item.title}>
                  <CustomButton
                    size="large"
                    variant="contained"
                    color="secondary"
                    icon={true}
                    slug={SLUG_DOWNLOAD}
                    title={BUTTON_DOWNLOAD}
                    type="click"
                    clickHandler={() => handleDownload(item.url, item.title)}
                  />
                </Box>
              )
            );
          })}
        </Box>

        <ErrorMessage errors={errors} modal={modal} />
      </Box>

      <Backdrop sx={{ color: "#fff", zIndex: 1301 }} open={backdrop}>
        <Box
          flexDirection="column"
          display="flex"
          justifyContent="center"
          sx={{ width: "100%" }}
          textAlign="center"
        >
          <Typography variant="body1">
            Processing request, please wait.
          </Typography>
          <Box mt={2}>
            <CircularProgress color="inherit" />
          </Box>
        </Box>
      </Backdrop>

      {modal.snackbar && (
        <NotificationMessage
          open={modal.snackbar}
          message="Insta policy confirmation document has been shared with you on your registered mobile number and email address."
          onClose={() => toggleModal("snackbar", false)}
        />
      )}
    </Box>
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  BuyflowInstaConfirmation
);
